import React from 'react'

const NotFound = () => {
  return (
    <div className='not-found'
    >
        <p>
            Chức năng đang được phát triển. Vui lòng quay lại sau.
        </p>
    </div>
  )
}

export default NotFound